// One clipboard write for the console's copy controls — and the one place that
// answers whether it LANDED.
//
// `void navigator.clipboard?.writeText(x)` is the shape this app grew in eight
// places. It has two silent failures: the `?.` swallows an absent clipboard
// (any non-secure context — a LAN address, a preview host, an in-app webview)
// and a rejected write escapes an async handler as a floating promise. Both
// read as "the click did nothing", which is the refusal-vs-nothing-happened
// line the house rule draws.
//
// The onboarding funnel is what made it expensive: copying the setup prompt
// also ADVANCED the funnel, so a write that never happened moved the user past
// the only screen that showed the text they were meant to copy.
//
// Answers a boolean rather than throwing: every caller's next move is the same
// — say so — and an exception for "this browser has no clipboard" would be an
// error handling for a supported environment.
export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator?.clipboard?.writeText !== 'function') return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
